<app-modal-base
  [title]="dialogTitle"
  (onSubmitEvent)="onSubmit()"
  [loading]="loading"
  [isDisabled]="form.invalid"
>
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="pref-row">
          <div>
            <app-select
              [label]="'homeView'"
              [formControl]="form_homeView"
              [size]="12"
              [list]="viewList"
              [isEnum]="true"
              [isMultiple]="false"
              enumName="HomeViewType"
            ></app-select>
            <a
              class="info-icon"
              (click)="showHomeViewInfo()"
              appTooltip="Plus d'informations"
            >
              <mat-icon
                class="align-top"
                color="primary"
                aria-label="Plus d'informations"
                >info</mat-icon
              >
            </a>
          </div>
          <div>
            <mat-checkbox
              class="col-12"
              [formControl]="form_notificationSendMail"
              >{{ "notificationSendMail" | translate }}</mat-checkbox
            >
            <a
              class="info-icon"
              (click)="showNotificationMailInfo()"
              appTooltip="Plus d'informations"
            >
              <mat-icon
                class="align-top"
                color="primary"
                aria-label="Plus d'informations"
                >info</mat-icon
              >
            </a>
          </div>
          <div>
            <mat-checkbox
              class="col-12"
              [formControl]="form_notificationSendAppPush"
              >{{ "notificationSendAppPush" | translate }}</mat-checkbox
            ><a
              class="info-icon"
              (click)="showNotificationAppPushInfo()"
              appTooltip="Plus d'informations"
            >
              <mat-icon
                class="align-top"
                color="primary"
                aria-label="Plus d'informations"
                >info</mat-icon
              >
            </a>
          </div>
          <div>
            <mat-radio-group
              *ngIf="canSeeDefaultVisitModeType"
              [formControl]="form_defaultVisitModeType"
              class="col-12"
            >
              <mat-label>{{ "defaultVisitModeType" | translate }} :</mat-label>
              <mat-radio-button value="FULL">{{
                "enum.SharingVisitModeType.FULL" | translate
              }}</mat-radio-button>
              <mat-radio-button value="SIMPLE">{{
                "enum.SharingVisitModeType.SIMPLE" | translate
              }}</mat-radio-button>
            </mat-radio-group>
            <a
              class="info-icon"
              (click)="showDefaultVisiteModeTypeInfo()"
              appTooltip="Plus d'informations"
            >
              <mat-icon
                class="align-top"
                color="primary"
                aria-label="Plus d'informations"
                >info</mat-icon
              >
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
